const {enabled} = require('../../../config/analytics');

module.exports.initAnalytics = async function (router, store) {
    if (typeof window !== 'undefined'){
        if (enabled.matomo){
            let {init} = await import('./matomo');

            init(router, store);
        }

        if (enabled.gtm){
            let {init} = await import('./googleTagManager');

            init(router);
        }

        if (enabled.google){
            let {init} = await import('./globalSiteTag');

            init(router);
        }

        if (enabled.brevo){
            let {init} = await import('./brevo');

            init();
        }
    }
}

module.exports.loginUser = async function (user) {
    if (typeof window !== 'undefined'){
        if (enabled.matomo){
            let {loginUser} = await import('./matomo');

            loginUser(user);
        }

        if (enabled.brevo){
            let {loginUser} = await import('./brevo');

            loginUser(user);
        }
    }
}

module.exports.logoutUser = async function () {
    if (typeof window !== 'undefined'){
        if (enabled.matomo){
            let {logoutUser} = await import('./matomo');

            logoutUser();
        }

        if (enabled.brevo){
            let {logoutUser} = await import('./brevo');

            logoutUser();
        }
    }
}

module.exports.trackEvent = async function (event, context, data) {
    if (typeof window !== 'undefined' && enabled.tracking){
        if (enabled.gtm){
            let {trackEvent} = await import('./googleTagManager');

            trackEvent(event, context, data);
        }
    }
}